/**
 * @file contains all environment options
 */

export const ENV_PRODUCTION = 'production';
